<template>
    <div class="list-group">
        <div class="list-group-item"
             :key="subscription.id"
             v-for="subscription in subscriptions">
            <div class="row">
                <div class="col-7">
                    <div class="small text-muted flex-grow-1">
                        {{ subscription.fromDate | date }}-{{ subscription.toDate | date }}, {{
                        subscription.minDuration
                        }}h
                    </div>
                    <div class="d-block">
                        <div class="font-weight-bold flex-grow-1">
                            {{ subscription.email }}
                        </div>
                    </div>
                </div>
                <div class="col-1">
                    {{ subscription.notificationCount }}&times;
                </div>
                <div class="col-2">
                    <button class="btn btn-danger btn-sm" @click="$emit('delete', subscription.id)">Löschen</button>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                        <span v-for="weekday of subscription.weekdays"
                              :key="subscription.id + '_' + weekday"
                              class="badge-pill"
                              :class="{'badge-success': subscription[weekday], 'badge-danger': !subscription[weekday]}">
                            {{ weekday }}
                        </span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    props: {
        subscriptions: Array
    }
}
</script>
